<!--begin::Menu wrapper-->
<div
  id="kt_app_sidebar_menu_scroll"
  class="mx-3 my-5 scroll-y"
  data-kt-scroll="true"
  data-kt-scroll-activate="true"
  data-kt-scroll-height="auto"
  data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer"
  data-kt-scroll-wrappers="#kt_app_sidebar_menu"
  data-kt-scroll-offset="5px"
  data-kt-scroll-save-state="true"
>
  <!--begin::Menu-->
  <div
    class="menu menu-column menu-rounded menu-sub-indention fw-semibold fs-6"
    id="#kt_app_sidebar_menu"
    data-kt-menu="true"
    data-kt-menu-expand="false"
  >
    <!-- Menu -->
    @for (section_menu of visibleNavigationMenu(); track $index) {
    <div class="menu-item">
      <!-- Menu Item -->
      @if (section_menu.type === 'item') {
      <section>
        <ng-container
          [ngTemplateOutlet]="item"
          [ngTemplateOutletContext]="{ menu: section_menu }"
        ></ng-container>
      </section>
      }
      <!-- Menu Accordion -->
      @if (section_menu.type === 'accordion') {
      <section>
        <ng-container
          [ngTemplateOutlet]="accordion"
          [ngTemplateOutletContext]="{ menu: section_menu }"
        ></ng-container>
      </section>
      }
      <!-- Menu Section -->
      @if (section_menu.type === 'section') {
      <section>
        <ng-container
          [ngTemplateOutlet]="section"
          [ngTemplateOutletContext]="{ menu: section_menu }"
        ></ng-container>
      </section>
      }
    </div>
    }
  </div>
  <!--end::Menu-->
</div>
<!--end::Menu wrapper-->

<!-- Template Menu Item -->
<ng-template #item let-menu="menu">
  <a
    class="menu-link without-sub"
    [routerLink]="menu.url"
    routerLinkActive="active"
  >
    @if (menu.icon?.length) {
    <span class="menu-icon">
      <app-keenicon
        [name]="menu.icon!"
        class="fs-2 svg-icon svg-icon-2"
      ></app-keenicon>
    </span>
    }@else {
    <span class="menu-bullet">
      <span class="bullet bullet-dot"></span>
    </span>
    }
    <span class="menu-title">{{ menu.title | translate }}</span>
    <!-- <span class="menu-title" translate="MENU.DASHBOARD"></span> -->
  </a>
</ng-template>

<!-- Template Menu Accordion -->
<ng-template #accordion let-menu="menu">
  <div
    class="menu-item menu-accordion"
    [ngClass]="menu.classes"
    data-kt-menu-trigger="click"
    routerLinkActive="here show"
  >
    <span class="menu-link">
      <span class="menu-icon">
        <app-keenicon
          [name]="menu.icon!"
          class="fs-2 svg-icon svg-icon-2"
        ></app-keenicon>
      </span>
      <span class="menu-title" [attr.data-link]="menu.url"
        >{{ menu.title | translate }}
      </span>
      <span class="menu-arrow"></span>
    </span>
    <div class="menu-sub menu-sub-accordion" routerLinkActive="menu-active-bg">
      @for (sub_menu of menu.children!; track $index) {
      <section>
        <!-- Menu Section accordion with sub-menu accordion -->
        @if (sub_menu.type === 'accordion') {
        <div
          class="menu-item menu-accordion"
          routerLinkActive="here show"
          data-kt-menu-trigger="click"
        >
          <span class="menu-link">
            <span class="menu-bullet">
              <span class="bullet bullet-dot"></span>
            </span>
            <span class="menu-title" [attr.data-link]="sub_menu.url"
              >{{ sub_menu.title | translate }}
            </span>
            <span class="menu-arrow"></span>
          </span>
          <div
            class="menu-sub menu-sub-accordion"
            routerLinkActive="menu-active-bg"
          >
            @for (children of sub_menu.children; track $index) {
            <div class="menu-item">
              <app-side-menu-item [menu]="children"></app-side-menu-item>
            </div>
            }
          </div>
        </div>
        }
        <!-- Menu Section accordion with sub-menu item -->
        @if (sub_menu.type === 'item') {
        <div class="menu-item">
          <a
            class="menu-link without-sub"
            [routerLink]="sub_menu.url"
            routerLinkActive="active"
          >
            @if (sub_menu.icon?.length) {
            <span class="menu-icon">
              <app-keenicon
                [name]="sub_menu.icon!"
                class="fs-2 svg-icon svg-icon-2"
              ></app-keenicon>
            </span>
            }@else {
            <span class="menu-bullet">
              <span class="bullet bullet-dot"></span>
            </span>
            }
            <span class="menu-title" [attr.data-link]="sub_menu.url">{{
              sub_menu.title | translate
            }}</span>
          </a>
        </div>
        }
      </section>
      }
    </div>
  </div>
</ng-template>

<!-- Template Menu Section -->
<ng-template #section let-menu="menu">
  <div class="menu-item">
    <div class="pt-8 pb-2 menu-content">
      <span class="menu-section text-muted text-uppercase fs-8 ls-1">{{
        menu.title | translate
      }}</span>
    </div>
  </div>
  @for (sub_menu of menu.children; track $index) {
  <section>
    <!-- Menu Section accordion -->
    @if (sub_menu.type === 'accordion') {
    <div
      class="menu-item menu-accordion"
      data-kt-menu-trigger="click"
      routerLinkActive="here show"
    >
      <span class="menu-link">
        <span class="menu-icon">
          <app-keenicon
            [name]="sub_menu.icon!"
            class="fs-2 svg-icon svg-icon-2"
          ></app-keenicon>
        </span>
        @if (sub_menu?.children![0]?.type==='accordion') {
        <span class="menu-title">{{ sub_menu.title | translate }}</span>
        } @else if (sub_menu.children[0]?.type==='item') {
        <span class="menu-title" [attr.data-link]="sub_menu.url">{{
          sub_menu.title | translate
        }}</span>
        }
        <!-- <span class="menu-title" [attr.data-link]="sub_menu.url">{{
            sub_menu.title | translate
          }}</span> -->
        <span class="menu-arrow"></span>
      </span>
      <div
        class="menu-sub menu-sub-accordion"
        routerLinkActive="menu-active-bg"
      >
        @for (children of sub_menu.children!; track $index) {
        <section>
          <!-- Menu Section accordion with sub-menu accordion -->
          @if (children.type === 'accordion') {
          <div
            class="menu-item menu-accordion"
            routerLinkActive="here show"
            data-kt-menu-trigger="click"
          >
            <span class="menu-link">
              <span class="menu-bullet">
                <span class="bullet bullet-dot"></span>
              </span>
              <span class="menu-title" [attr.data-link]="children.url"
                >{{ children.title | translate }}
              </span>
              <span class="menu-arrow"></span>
            </span>
            <div
              class="menu-sub menu-sub-accordion"
              routerLinkActive="menu-active-bg"
            >
              @for (sub_children of children.children; track $index) {
              <div class="menu-item">
                <a
                  class="menu-link without-sub"
                  [routerLink]="sub_children.url"
                  routerLinkActive="active"
                >
                  @if (sub_children.icon?.length) {
                  <span class="menu-icon">
                    <app-keenicon
                      [name]="sub_children.icon!"
                      class="fs-2 svg-icon svg-icon-2"
                    ></app-keenicon>
                  </span>
                  }@else {
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  }
                  <span
                    class="menu-title"
                    [attr.data-link]="sub_children.url"
                    >{{ sub_children.title | translate }}</span
                  >
                  <!-- <span class="menu-title" translate="MENU.DASHBOARD"></span> -->
                </a>
              </div>
              }
            </div>
          </div>
          }
          <!-- Menu Section accordion with sub-menu item -->
          @if (children.type === 'item') {
          <div class="menu-item">
            <a
              class="menu-link without-sub"
              [routerLink]="children.url"
              routerLinkActive="active"
            >
              @if (children.icon?.length) {
              <span class="menu-icon">
                <app-keenicon
                  [name]="children.icon!"
                  class="fs-2 svg-icon svg-icon-2"
                ></app-keenicon>
              </span>
              }@else {
              <span class="menu-bullet">
                <span class="bullet bullet-dot"></span>
              </span>
              }
              <span class="menu-title" [attr.data-link]="children.url">{{
                children.title | translate
              }}</span>
              <!-- <span class="menu-title" translate="MENU.DASHBOARD"></span> -->
            </a>
          </div>
          }
        </section>
        }
      </div>
    </div>
    <!-- <app-side-menu-accordion [menu]="sub_menu"></app-side-menu-accordion> -->
    }
    <!-- Menu Section item -->
    @if (sub_menu.type === 'item') {
    <div class="menu-item">
      <a
        class="menu-link without-sub"
        [routerLink]="sub_menu.url"
        routerLinkActive="active"
      >
        @if (sub_menu.icon?.length) {
        <span class="menu-icon">
          <app-keenicon
            [name]="sub_menu.icon!"
            class="fs-2 svg-icon svg-icon-2"
          ></app-keenicon>
        </span>
        }@else {
        <span class="menu-bullet">
          <span class="bullet bullet-dot"></span>
        </span>
        }
        <span class="menu-title" [attr.data-link]="sub_menu.url">{{
          sub_menu.title | translate
        }}</span>
        <!-- <span class="menu-title" translate="MENU.DASHBOARD"></span> -->
      </a>
    </div>
    }
  </section>
  }
</ng-template>
